const PagedList = require('../entities/paged-list');

const FlowTemplate = require('../entities/flows/flow-template');

const Flow = require('../entities/flows/flow');

class FlowsRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  list()
  /*: Promise<PagedList<FlowTemplate>>*/
  {
    const req = new this.client.Request(`/offers/flows/templates`);
    return this.client.get(req);
  }

  details(templateId
  /*: string*/
  , vars
  /*: any*/
  )
  /*: Promise<FlowTemplate>*/
  {
    const data = vars && {
      vars: JSON.stringify(vars)
    };
    const req = new this.client.Request(`/offers/flows/templates/${templateId}`, data);
    req.parse = FlowTemplate.fromJson;
    return this.client.get(req);
  }

  initialize(templateId
  /*: string*/
  , vars
  /*: any*/
  )
  /*: Promise<Flow>*/
  {
    return this.details(templateId, vars).then(template => new Flow({
      template
    }));
  }

}

module.exports = FlowsRepo;